import { render, staticRenderFns } from "./ReviewComponent.vue?vue&type=template&id=b73c4dac&scoped=true"
import script from "./ReviewComponent.vue?vue&type=script&lang=js"
export * from "./ReviewComponent.vue?vue&type=script&lang=js"
import style0 from "./ReviewComponent.vue?vue&type=style&index=0&id=b73c4dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73c4dac",
  null
  
)

export default component.exports